import { z } from 'zod';

export const questionClientMapSchema = z.object({
  form_question_id: z.number().int().positive(),
  client_id: z.number().int().positive(),
  external_question_id: z.string().min(1),
  external_options_id: z.array(
    z.object({
      form_option_id: z.number().int().positive(),
      external_option_id: z.string().min(1),
    })
  ),
});
export type QuestionClientInput = z.infer<typeof questionClientMapSchema>;
